const t=t=>t.map((t=>({target:t.dataset.toc||"",text:t.textContent||""})));export{t as headingsHandler};
//# sourceMappingURL=headingHandler.js.map
